import { createRequestTypes } from '../utils';

export const FETCH_SHADE_PROPORTIONS = createRequestTypes('shadeProportion/FETCH_SHADE_PROPORTIONS');
export const DELETE_SHADE_PROPORTION = createRequestTypes('shadeProportion/DELETE_SHADE_PROPORTION');
export const SAVE_SHADE_PROPORTIONS = createRequestTypes('shadeProportion/SAVE_SHADE_PROPORTIONS');
